import React from 'react'
import './adminApp.css';
import Sidebar from './components/Sidebar';

export default function adminLeaveRequest() {
    return (
        <>
            <div className="txt-container">
                <Sidebar />
                <div>
                    <h1>Admin Leave Request page</h1>
                </div>
            </div>
        </>
    )
}
